import Box, { BoxProps } from '@mui/material/Box'
import { ReactElement, ReactNode } from 'react'

type DisplayProp = BoxProps['display']

interface BaseProps {
    /**
     * The content of the component.
     */
    children: ReactNode | ReactNode[]
    /**
     * Specify which display styles to use. Accepts anything that can be passed to `display` on the `<Box sx>` prop.
     * @default undefined
     */
    display?: DisplayProp
    width?: string
}

interface MobileProps extends BaseProps {
    /**
     * Shortcut to display the content only on mobile
     */
    mobile: true
    desktop?: never
}

interface DesktopProps extends BaseProps {
    /**
     * Shortcut to display the content only on desktop
     */
    desktop: true
    mobile?: never
}

interface CustomizedDisplayProps extends BaseProps {
    /**
     * Specify which display styles to use. Accepts anything that can be passed to `sx.display`.
     */
    display: DisplayProp
    mobile?: never
    desktop?: never
}

export type VisibleProps = MobileProps | DesktopProps | CustomizedDisplayProps

function Visible({ display, mobile, desktop, children, width }: VisibleProps): ReactElement {
    if (mobile) {
        display = {
            sm: 'none',
            xs: 'block',
        }
    } else if (desktop) {
        display = {
            xs: 'none',
            sm: 'block',
        }
    }

    return <Box sx={{ display, width }}>{children}</Box>
}

export default Visible
